ACC.address = {

    _autoload: [
        'bindToChangeAddressButton',
        'bindCreateUpdateAddressForm',
        'bindSuggestedDeliveryAddresses',
        'bindCountrySpecificAddressForms',
        'showAddressFormButtonPanel',
        'bindViewAddressBook',
        'bindToColorboxClose',
        'showRemoveAddressFromBookConfirmation',
        'showCancelAddressChangesConfirmation',
        'bindCheckCountryDropdownChanges',
        'searchAddress',
        'bindFocusOnSearchInput',
        'bindCountrySpecificRegionsChange',
        'bindIslandsSpecificAddressForms',
        ['onFocusToErrorInput', document.querySelector('#addressForm')],
        ['formatPostalCode', document.querySelector('#address\\.postcode')
        && document.querySelector('[data-sitename="learneruk"]')],
        ['formatCanadaPostalCode', document.querySelector('#i18nAddressForm')
        && document.querySelector('#address\\.postcode')
        && ACC.config.checkoutZipChangesEnabled],
        ['start', document.querySelector('#addressForm')],
    ],

    start() {
        ACC.address.trackFormChanges();
    },

    spinner: $(`<img src='${ACC.config.commonResourcePath}/images/spinner.gif' />`),
    addressID: '',

    formatCanadaPostalCode() {
        if ((ACC.utils.isHedTheme() || ACC.utils.isMojoTheme())
            && ACC.config.checkoutZipChangesEnabled) {
            $('#address\\.postcode').on('keyup', (event) => {
                const postcodeField = event.target;
                const countryField = document.querySelector('#address\\.country');
                const countryValue = countryField.value;
                if (countryValue === 'CA') {
                    if (postcodeField.value.length >= 4 && event.keyCode !== 8 && postcodeField.value[3] !== ' ') {
                        ACC.address.addSpaceOnSpecifiedPosition(postcodeField, 3);
                        return;
                    }
                    if (postcodeField.value.length === 4 && postcodeField.value[3] === ' ' && event.keyCode === 8) {
                        postcodeField.value = postcodeField.value.substring(0, 3);
                        // eslint-disable-next-line no-useless-return
                        return;
                    }
                }
            });
        }
    },

    handleChangeAddressButtonClick() {
        ACC.address.addressID = ($(this).data('address')) ? $(this).data('address') : '';
        $('#summaryDeliveryAddressFormContainer').show();
        $('#summaryOverlayViewAddressBook').show();
        $('#summaryDeliveryAddressBook').hide();

        // eslint-disable-next-line no-undef
        $.getJSON(getDeliveryAddressesUrl, ACC.address.handleAddressDataLoad);
        return false;
    },

    handleAddressDataLoad(data) {
        ACC.address.setupDeliveryAddressPopupForm(data);

        // Show the delivery address popup
        ACC.colorbox.open('', {
            inline: true,
            href: '#summaryDeliveryAddressOverlay',
            overlayClose: false,
            onOpen() {
                // empty address form fields
                ACC.address.emptyAddressForm();
                $(document).on('change', '#saveAddress', function () {
                    const saveAddressChecked = $(this).prop('checked');
                    $('#defaultAddress').prop('disabled', !saveAddressChecked);
                    if (!saveAddressChecked) {
                        $('#defaultAddress').prop('checked', false);
                    }
                });
            },
        });
    },

    setupDeliveryAddressPopupForm(data) {
        // Fill the available delivery addresses
        $('#summaryDeliveryAddressBook').html($('#deliveryAddressesTemplate').tmpl({ addresses: data }));
        // Handle selection of address
        $('#summaryDeliveryAddressBook button.use_address').click(ACC.address.handleSelectExistingAddressClick);
        // Handle edit address
        $('#summaryDeliveryAddressBook button.edit').click(ACC.address.handleEditAddressClick);
        // Handle set default address
        $('#summaryDeliveryAddressBook button.default').click(ACC.address.handleDefaultAddressClick);
    },

    emptyAddressForm() {
        const options = {
            // eslint-disable-next-line no-undef
            url: getDeliveryAddressFormUrl,
            data: { addressId: ACC.address.addressID, createUpdateStatus: '' },
            type: 'GET',
            success(data) {
                $('#summaryDeliveryAddressFormContainer').html(data);
                ACC.address.bindCreateUpdateAddressForm();
            },
        };

        $.ajax(options);
    },

    handleSelectExistingAddressClick() {
        const addressId = $(this).attr('data-address');
        // eslint-disable-next-line no-undef
        $.postJSON(setDeliveryAddressUrl, { addressId }, ACC.address.handleSelectExitingAddressSuccess);
        return false;
    },

    handleEditAddressClick() {
        $('#summaryDeliveryAddressFormContainer').show();
        $('#summaryOverlayViewAddressBook').show();
        $('#summaryDeliveryAddressBook').hide();

        const addressId = $(this).attr('data-address');
        const options = {
            // eslint-disable-next-line no-undef
            url: getDeliveryAddressFormUrl,
            data: { addressId, createUpdateStatus: '' },
            target: '#summaryDeliveryAddressFormContainer',
            type: 'GET',
            success() {
                ACC.address.bindCreateUpdateAddressForm();
                ACC.colorbox.resize();
            },
            error(xht, textStatus, ex) {
                // eslint-disable-next-line no-alert
                alert(`Failed to update cart. Error details [${xht}, ${textStatus}, ${ex}]`);
            },
        };

        $(this).ajaxSubmit(options);
        return false;
    },

    handleDefaultAddressClick() {
        const addressId = $(this).attr('data-address');
        const options = {
            // eslint-disable-next-line no-undef
            url: setDefaultAddressUrl,
            data: { addressId },
            type: 'GET',
            success(data) {
                ACC.address.setupDeliveryAddressPopupForm(data);
            },
            error(xht, textStatus, ex) {
                // eslint-disable-next-line no-alert
                alert(`Failed to update address book. Error details [${xht}, ${textStatus}, ${ex}]`);
            },
        };

        $(this).ajaxSubmit(options);
        return false;
    },

    handleSelectExitingAddressSuccess(data) {
        if (data != null) {
            ACC.refresh.refreshPage(data);
            ACC.colorbox.close();
        } else {
            // eslint-disable-next-line no-alert
            alert('Failed to set delivery address');
        }
    },

    bindCreateUpdateAddressForm() {
        $('.create_update_address_form').each(function () {
            const options = {
                type: 'POST',
                beforeSubmit() {
                    $('#checkout_delivery_address').block({ message: ACC.address.spinner });
                },
                success(data) {
                    $('#summaryDeliveryAddressFormContainer').html(data);
                    const status = $('.create_update_address_id').attr('status');
                    if (status != null && status.toLowerCase() === 'success') {
                        ACC.refresh.getCheckoutCartDataAndRefreshPage();
                        ACC.colorbox.close();
                    } else {
                        ACC.address.bindCreateUpdateAddressForm();
                        ACC.colorbox.resize();
                    }
                },
                error(xht, textStatus, ex) {
                    // eslint-disable-next-line no-alert
                    alert(`Failed to update cart. Error details [${xht}, ${textStatus}, ${ex}]`);
                },
                complete() {
                    $('#checkout_delivery_address').unblock();
                },
            };

            $(this).ajaxForm(options);
        });
    },

    refreshDeliveryAddressSection(data) {
        $('.summaryDeliveryAddress').replaceWith($('#deliveryAddressSummaryTemplate').tmpl(data));
    },

    bindSuggestedDeliveryAddresses() {
        const status = $('.add_edit_delivery_address_id').attr('status');
        if (status != null && status === 'hasSuggestedAddresses') {
            ACC.address.showSuggestedAddressesPopup();
        }
    },

    showSuggestedAddressesPopup() {
        $modal.open(null, {
            inline: true,
            href: '#popup_suggested_delivery_addresses_form',
            title: "We couldn't verify your address",
        });

        const modal = document.getElementById('colorbox');
        if (modal.querySelector('#popup_suggested_delivery_addresses_form')) {
            const suggestedAddressesForm = document.getElementById('popup_suggested_delivery_addresses_form');
            const bodyMobile = document.querySelector('.iti-mobile');
            const checkIsMobile = !!bodyMobile;
            const reenterAddressButton = document.getElementById('reenter_address_button');

            if (suggestedAddressesForm) {
                // eslint-disable-next-line max-len
                suggestedAddressesForm.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add('suggestedAddresses__modal');
                suggestedAddressesForm.classList.add('isVisible');
                if (checkIsMobile) {
                    bodyMobile.classList.add('isMobile');
                }

                document.getElementById('cboxOverlay').addEventListener('click', () => {
                    if (checkIsMobile) {
                        bodyMobile.classList.remove('isMobile');
                    }
                    suggestedAddressesForm.classList.remove('isVisible');
                    modal.classList.remove('suggestedAddresses__modal');
                });

                document.addEventListener('keyup', (event) => {
                    if (event.keyCode === 27) {
                        if (checkIsMobile) {
                            bodyMobile.classList.remove('isMobile');
                        }
                        suggestedAddressesForm.classList.remove('isVisible');
                        modal.classList.remove('suggestedAddresses__modal');
                    }
                });

                document.getElementById('cboxClose').addEventListener('click', () => {
                    if (checkIsMobile) {
                        bodyMobile.classList.remove('isMobile');
                    }
                    suggestedAddressesForm.classList.remove('isVisible');
                    modal.classList.remove('suggestedAddresses__modal');
                });

                if (reenterAddressButton) {
                    reenterAddressButton.addEventListener('click', () => {
                        $modal.close();
                        if (checkIsMobile) {
                            bodyMobile.classList.remove('isMobile');
                        }
                        suggestedAddressesForm.classList.remove('isVisible');
                        modal.classList.remove('suggestedAddresses__modal');
                    });
                }
            }
        }
    },

    bindIslandsSpecificAddressForms() {
        $('#addressForm [name=countryIso]').on('change', function () {
            const options = {
                addressCode: '',
                countryIsoCode: $(this).val(),
            };
            ACC.address.displayIslandsSpecificAddressForm(options, ACC.address.bindIslandsSpecificAddressForms);
        });
    },
    bindCountrySpecificAddressForms() {
        $(document).on('change', '#countrySelector select', function () {
            const options = {
                addressCode: '',
                countryIsoCode: $(this).val(),
            };
            ACC.address.displayCountrySpecificAddressForm(options, ACC.address.showAddressFormButtonPanel);
        });
    },

    showAddressFormButtonPanel() {
        if ($('#countrySelector :input').val() !== '') {
            $('#addressform_button_panel').show();
        }
    },

    bindToColorboxClose() {
        $('.closeColorBox').on('click', () => {
            $modal.close();
        });
    },

    displayCountrySpecificAddressForm(options, callback) {
        $.ajax({
            url: `${ACC.config.encodedContextPath}/my-account/addressform`,
            async: true,
            data: options,
            dataType: 'html',
            beforeSend() {
                $('#i18nAddressForm').html(ACC.address.spinner);
            },
        }).done((data) => {
            $('#i18nAddressForm').html($(data).html());
            ACC.phonemasking.bind($('#address\\.phone'), options.countryIsoCode);
            if (typeof callback === 'function') {
                callback.call();
            }
        });
    },

    displayIslandsSpecificAddressForm(options, callback) {
        $.ajax({
            url: `${ACC.config.encodedContextPath}/checkout/multi/delivery-address/addressform`,
            async: true,
            data: options,
            dataType: 'html',
            beforeSend() {
                $('#i18nAddressForm').html(ACC.address.spinner);
            },
        }).done((data) => {
            $('#i18nAddressForm').html($(data).html());
            ACC.phonemasking.bind($('#address\\.phone'), options.countryIsoCode);
            if (typeof callback === 'function') {
                callback.call();
            }
            ACC.address.formatPostalCode();
        });
    },

    bindToChangeAddressButton() {
        $(document).on('click', '.summaryDeliveryAddress .editButton', ACC.address.handleChangeAddressButtonClick);
    },

    bindViewAddressBook() {
        $('.js-address-book').on('click', function () {
            $modal.open(this);
        });

        $(document).on('click', '#summaryOverlayViewAddressBook', () => {
            $('#summaryDeliveryAddressFormContainer').hide();
            $('#summaryOverlayViewAddressBook').hide();
            $('#summaryDeliveryAddressBook').show();
            ACC.colorbox.resize();
        });
    },

    showRemoveAddressFromBookConfirmation() {
        $('.removeAddressFromBookButton').on('click', function () {
            $modal.open(this, {
                onOpen() {
                    const modalContent = document.getElementById('cboxContent');
                    const options = {
                        childList: true,
                    };
                    const observer = new MutationObserver(((mutations) => {
                        if (mutations.length) {
                            const modalHeading = document.querySelector('#cboxTitle .headline');
                            if (modalHeading) {
                                modalHeading.setAttribute('tabindex', '-1');
                                modalHeading.focus();
                            }
                        }
                    }));
                    observer.observe(modalContent, options);
                },
            });
        });
    },

    trackFormChanges() {
        const eventType = (ACC.addressvalidation.isCheckoutZipChangeApplicableForFunction()) ? 'input' : 'change';
        $('#addressForm').on(eventType, () => {
            $('.i18nAddressForm').data('changed', true);
            ACC.addressvalidation.changeSubmitButtonRequiredFields();
        });
    },

    showCancelAddressChangesConfirmation() {
        $('.js-cancel-address-changes-popup-button').on('click', function () {
            if ($('.i18nAddressForm').data('changed')) {
                $modal.open(this);
            } else {
                window.location = $(this).data('cancelUrl');
            }
        });
    },

    bindCheckCountryDropdownChanges() {
        const dropdownElement = $('#address\\.country');
        const saveAddressComponent = $('#saveAddressInMyAddressBookComponent');
        const saveAddressCheckbox = $('#saveAddressInMyAddressBook');
        if (!dropdownElement.length) {
            return;
        }

        saveAddressComponent.show();
        if (!ACC.address.checkIfCountryIsInPearsonList()) {
            saveAddressCheckbox.prop('checked', false);
            saveAddressComponent.hide();
        }
        dropdownElement.change(() => {
            if (!ACC.address.checkIfCountryIsInPearsonList()) {
                saveAddressCheckbox.prop('checked', false);
                saveAddressComponent.hide();
            } else {
                saveAddressComponent.show();
            }
        });
    },

    checkIfCountryIsInPearsonList() {
        const addressCountry = $('#address\\.country');
        if (!addressCountry.length) {
            return;
        }
        const selectedCountryCode = addressCountry.find(':selected').val();
        const divWithIsoCodes = $('.countrySelector');
        if (!divWithIsoCodes.length) {
            return;
        }
        const isoCodesAsString = divWithIsoCodes[0].dataset.pearsonsupportedisocodes;

        // eslint-disable-next-line eqeqeq
        if (isoCodesAsString === '' || isoCodesAsString.includes(selectedCountryCode)) {
            // eslint-disable-next-line consistent-return
            return true;
        }
        // eslint-disable-next-line consistent-return
        return false;
    },

    searchAddress() {
        const searchInput = $('#js-address-search-input');
        if (searchInput.length > 0) {
            const autocompleteOptions = {
                appendTo: searchInput,
                inputField: searchInput,
                delay: 500,
                minLength: 0,
                defaultMinLength: 0,
                autocompleteUrl: searchInput.data('search-url'),
                encodedContextPath: ACC.config.encodedContextPath,
            };
            // eslint-disable-next-line no-undef
            addAutocomplete(autocompleteOptions);
        }
    },

    bindFocusOnSearchInput() {
        $('#js-address-search-input').focus(() => {
            const inputField = $('#js-address-search-input');
            if (inputField.val().length < 3) {
                const keyEvent = $.Event('keydown');
                keyEvent.keyCode = $.ui.keyCode.SPACE;
                inputField.trigger(keyEvent);
            }
        });
    },

    bindCountrySpecificRegionsChange() {
        $(document).on('change', '#dynamic-region-load-for-country #address\\.country', function () {
            ACC.address.loadCountryRegions($(this).val());
        });
    },

    loadCountryRegions(countryIso) {
        $.ajax({
            url: `${ACC.config.encodedContextPath}/address/country/${countryIso}/regions`,
            async: true,
        }).done((regions) => {
            const regionsDropdown = $('#address\\.region');
            regionsDropdown.find('option:not(:first-child)').remove();
            $.each(regions, function () {
                $('<option>', { value: this.isocode, text: this.name }).appendTo(regionsDropdown);
            });
            regionsDropdown.find('option:first').prop('selected', 'selected');
        });
    },

    formatPostalCode() {
        const currentCountry = document.querySelector('#address\\.country').value;
        const postCodeField = document.querySelector('#address\\.postcode');

        ACC.address.setFormattingOptions(currentCountry, postCodeField);

        postCodeField.addEventListener('focusout', (event) => {
            ACC.address.setFormattingOptions(currentCountry, event.target);
        });

        postCodeField.addEventListener('keypress', (event) => {
            if (event.key === 'Enter') {
                ACC.address.setFormattingOptions(currentCountry, event.target);
            }
        });
    },

    setFormattingOptions(currentCountry, field) {
        if (currentCountry === 'GB' && field.value.length >= 5 && field.value.length <= 7
            && !field.value.includes(' ')) {
            ACC.address.addSpaceOnSpecifiedPosition(field, -3);
        }
        if (currentCountry === 'IE' && field.value.length === 7 && !field.value.includes(' ')) {
            ACC.address.addSpaceOnSpecifiedPosition(field, -4);
        }
    },

    addSpaceOnSpecifiedPosition(field, spacePosition) {
        const array = field.value.split('');
        array.splice(spacePosition, 0, ' ');
        field.value = array.join('');
    },

    onFocusToErrorInput() {
        window.onload = () => {
            const firstErrorBlock = document.querySelector('.form-group.has-error');
            setTimeout(() => {
                if (firstErrorBlock) {
                    firstErrorBlock.querySelector('[name]').focus();
                }
            }, 100);
        };
    },
};
